<template>
    <div>
        <div class="categoryComp" id="courseCategoryArea">

            <ul ref="courseLeft" class="categoryTree noMargin noPadding alignCenter hiddenScrollbar">
                <li v-on:click="onChange" data-id=""  class="firstLevelCategory" :class="{active: !selectedId }">
                    <span class="block color333" >
                        全部课程
                    </span>
                </li>
                <li class="firstLevelCategory" v-for="(item,index) in dataList" :key="index"
                    :class="{active: item.id == selectedId && selectedSecondId == ''}">
                        <span class="block color333" :data-id="item.id"
                              v-on:click="onChange">{{item.name}}</span>

                    <ul class="noPadding" style="font-size: 80%">
                        <li class="subItem" :class="{active: subItem.id == selectedSecondId}" v-for="(subItem,index) in (item.childsList ? item.childsList : [])" :key="index">
                            <span class="block" :data-id="item.id" :data-secondcategoryid="subItem.id"
                                v-on:click="onChange">{{subItem.name}}</span>
                        </li>
                    </ul>

                </li>

            </ul>
        </div>
    </div>
</template>
<script>
// part
import shixunPagePart from '../shixunApp/shixunPagePart';

// style
import './courseCategory.scss'

const config = {
    apiConfig : {
        list : {
            url : 'portal/course/classify/list_category_all',
            dataPath : 'data',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};

export default {
    name: "courseListLeft",
    extends : shixunPagePart,
    data(){
        return{

            enableDataList : true,
            autoLoadDataList : true,
            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,
            scrollControl:{
                viewContainer:window,
                scrollContainer : ".hiddenScrollbar"
            },

            selectedId: '',
            selectedFirstId : '',
            selectedSecondId : '',

            outputMap : {},
            layoutAdjustTimer : null,
        }
    },
    methods: {
        onChange: function (event) {
            var target = event.currentTarget;
            const id = target.dataset.id || '';
            var secondcategoryid = target.dataset.secondcategoryid || '';
            var parms = {}
            parms.categorySecondId = secondcategoryid
            parms.categoryFirstId = id

            this.$emit('changeCategory',parms)
            // set selected id
            this.selectedId = this.selectedFirstId = id;
            this.selectedSecondId = secondcategoryid;
        },

    },
    mounted(){
    }

}
</script>
<style lang="scss" scoped>

</style>
